import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ColorPickerModule } from 'ngx-color-picker';

import { AppConstants } from './../../../app.constants';

@Component({
  selector: 'app-color-picker',
  standalone: true,
  imports: [
    ColorPickerModule
  ],
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent {
  @Input() color: string;
  @Input() position: string;
  @Input() isInputHidden: boolean;
  @Input() label: string = 'Color';
  @Input() outputFormat: string = 'hex';
  @Input() isDisabled: boolean;
  @Output() colorChange: EventEmitter<string> = new EventEmitter();

  public presetColors = AppConstants.COLOR_PICKER_PRESET_COLORS;
}
